import React from 'react';
import Column from '@amzn/meridian/column';
import Breadcrumb, { BreadcrumbGroup } from '@amzn/meridian/breadcrumb';
import {
    buildGetContainerDetailsInput,
    GetContainerDetailsInput,
    GetContainerDetailsOutput,
    GetContainerMode
} from 'src/models/GetContainerDetails';
import * as AppRoutes from 'src/routing/constants/routes';
import * as AppStrings from 'src/localization/string-ids/app-strings';
import SearchedContainerDetailsTableForScanners
    from 'src/components/pages/search-page/search-for-scanner/searched-container-page/searched-container-table-for-scanners/SearchedContainerDetailsTableForScannersContainer';
import SearchInput from 'src/components/common/search-input/SearchInput';


interface SearchedContainerPageStateProps {
    containerDetails?: GetContainerDetailsOutput;
    warehouseId: string,
    associate: string,
    locale: string
}

interface SearchedContainerPageDispatchProps {
    fetchContainerDetails: (getContainerDetailsInput: GetContainerDetailsInput) => void;
}

type Props = SearchedContainerPageStateProps & SearchedContainerPageDispatchProps;

/*
    This component is to render the details of container that is searched.
    For example, if we search for a PALLET - it will render its details
    like pallet ID, no. of TOTEs inside PALLET, no. of ITEMs inside PALLET, etc.
*/
class SearchedContainerPage extends React.Component<Props> {

    private onSearchSubmit = async (containerId: string) => {
        await this.props.fetchContainerDetails(buildGetContainerDetailsInput(containerId, this.props.warehouseId,
            this.props.associate, this.props.locale, GetContainerMode.SEARCH, true));
    }

    /*
        The breadcrumb contains `parent container > searched container` (e.g., PALLET_ID > TOTE_ID in case TOTE is searched)
        If user clicks on parent container ID, we should fetch container details of that parent container.
    */
    private onBreadcrumbClick = async (containerId: string) => {
        await this.props.fetchContainerDetails(buildGetContainerDetailsInput(containerId, this.props.warehouseId,
            this.props.associate, this.props.locale, GetContainerMode.SEARCH, true));
    }

    public render() {
        const containerId = this.props.containerDetails?.container?.containerId;
        const parentContainerId = this.props.containerDetails?.container?.parentContainer?.containerId;
        return (
            <Column className="search-for-scanner">
                <BreadcrumbGroup>
                    <Breadcrumb href={AppRoutes.HOME_PAGE_ROUTE}>{AppStrings.HOME}</Breadcrumb>
                    <Breadcrumb href={AppRoutes.SEARCH_PAGE_ROUTE}>{AppStrings.SEARCH}</Breadcrumb>
                </BreadcrumbGroup>

                <SearchInput
                    searchFieldLabel={AppStrings.SEARCH_INPUT_LABEL}
                    searchFieldPlaceholder={AppStrings.SEARCH_INPUT_PLACEHOLDER}
                    renderSearchButton={true}
                    onSubmit={this.onSearchSubmit}
                    data-testid="search-scanner-input"
                />

                {parentContainerId &&
                    <BreadcrumbGroup>
                        {parentContainerId &&
                            <Breadcrumb onClick={() => this.onBreadcrumbClick(parentContainerId)}>
                                {parentContainerId}
                            </Breadcrumb>
                        }
                        <Breadcrumb>{containerId}</Breadcrumb>
                    </BreadcrumbGroup>
                }
                {this.props.containerDetails && <SearchedContainerDetailsTableForScanners />}

            </Column>
        );
    }
}

export default SearchedContainerPage;
